import { TableColumn } from '../../../models/table-column';
import { TextKeys } from '../../../i18n/text-keys';
import { MaterialColumnsEnum } from './material-columns.enum';
import {MaterialFilterOptionsModel} from '../../../models/material/material-filter-options.model';

export const getTableColumns = (): TableColumn[] => [
  {
    name: MaterialColumnsEnum.Date,
    position: 0,
    selected: true,
    text: TextKeys.dayInfo.date,
  },
  {
    name: MaterialColumnsEnum.Name,
    position: 1,
    selected: true,
    text: TextKeys.expenses.name,
  },
  {
    name: MaterialColumnsEnum.Description,
    position: 2,
    selected: true,
    text: TextKeys.expenses.description,
  },
  {
    name: MaterialColumnsEnum.Number,
    position: 3,
    selected: true,
    text: TextKeys.expenses.numberLong,
  },
  {
    name: MaterialColumnsEnum.Quantity,
    position: 4,
    selected: true,
    text: TextKeys.quantity.quantity,
  },
  {
    name: MaterialColumnsEnum.Unit,
    position: 5,
    selected: true,
    text: TextKeys.items.unit,
  },
  {
    name: MaterialColumnsEnum.Price,
    position: 6,
    selected: true,
    text: TextKeys.items.price,
  },
  {
    name: MaterialColumnsEnum.Total,
    position: 7,
    selected: true,
    text: TextKeys.general.total,
  },
  {
    name: MaterialColumnsEnum.Note,
    position: 8,
    selected: true,
    text: TextKeys.note.title,
  },
  {
    name: MaterialColumnsEnum.FirstName,
    position: 9,
    selected: true,
    text: TextKeys.personal.firstName,
  },
  {
    name: MaterialColumnsEnum.LastName,
    position: 10,
    selected: true,
    text: TextKeys.personal.lastName,
  },
  {
    name: MaterialColumnsEnum.PersonalNR,
    position: 11,
    selected: true,
    text: TextKeys.personal.numberShort,
  },
];

export const getMaterialFilterOptions = (): MaterialFilterOptionsModel => ({
  note: {
    name: TextKeys.note.title,
    selected: false,
  },
  price: {
    name: TextKeys.items.price,
    selected: false,
  },
  unit: {
    name: TextKeys.items.unit,
    selected: false,
  },
  name: {
    name: TextKeys.expenses.name,
    selected: false,
  },
  description: {
    name: TextKeys.expenses.description,
    selected: false,
  },
  number: {
    name: TextKeys.expenses.numberLong,
    selected: false,
  },
  quantity: {
    name: TextKeys.quantity.quantity,
    selected: false,
  },
  firstName: {
    name: TextKeys.personal.firstName,
    selected: false,
  },
  lastName: {
    name: TextKeys.personal.lastName,
    selected: false,
  },
  personNR: {
    name: TextKeys.personal.numberLong,
    selected: false,
  },
});
